var map = {
	"./analys.gif": "7fcd",
	"./analys.svg": "3587",
	"./anamnez.gif": "a117",
	"./anamnez.svg": "592c",
	"./auskultation.gif": "1c86",
	"./auskultation.svg": "c6fa",
	"./complaints.gif": "735d",
	"./complaints.svg": "c00e",
	"./finalDiagnosis.gif": "8008",
	"./finalDiagnosis.svg": "352c",
	"./inspection.gif": "0b63",
	"./inspection.svg": "7e1f",
	"./instrumental.gif": "5a87",
	"./instrumental.svg": "a3b6",
	"./palpation.gif": "cecb",
	"./palpation.svg": "b45a",
	"./perkusion.gif": "f87a",
	"./perkusion.svg": "9812",
	"./preliminaryDiagnosis.gif": "5c75",
	"./preliminaryDiagnosis.svg": "439f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c05";